import { Check } from "lucide-react";
import { ScreenshotFrame } from "@/components/marketing/ScreenshotFrame";
import type { Shot } from "@/data/marketing";

interface ScreenshotSplitProps {
  shot: Shot;
  /** Index used to alternate the layout left/right */
  index: number;
  eyebrow?: string;
}

export function ScreenshotSplit({ shot, index, eyebrow }: ScreenshotSplitProps) {
  const reversed = index % 2 === 1;

  return (
    <div className="grid gap-8 lg:gap-14 lg:grid-cols-2 items-center">
      <div className={reversed ? "lg:order-2" : ""}>
        <ScreenshotFrame
          src={shot.image}
          alt={`TransportMate ${shot.title} screenshot`}
          url={shot.url}
          variant={shot.variant}
        />
      </div>
      <div className={reversed ? "lg:order-1" : ""}>
        {eyebrow && (
          <p className="text-xs font-semibold uppercase tracking-[0.14em] text-primary mb-2.5">{eyebrow}</p>
        )}
        <h3 className="text-xl sm:text-2xl md:text-3xl font-extrabold tracking-tight mb-3">{shot.title}</h3>
        <p className="text-sm sm:text-base text-muted-foreground leading-relaxed">{shot.desc}</p>
        {shot.bullets && (
          <ul className="mt-5 space-y-2.5">
            {shot.bullets.map((b) => (
              <li key={b} className="flex items-start gap-2.5">
                <span className="mt-0.5 h-5 w-5 rounded-full bg-primary/10 flex items-center justify-center flex-shrink-0">
                  <Check className="h-3 w-3 text-primary" />
                </span>
                <span className="text-sm text-foreground">{b}</span>
              </li>
            ))}
          </ul>
        )}
      </div>
    </div>
  );
}
